import { AuthService } from '@shared/services/guards/auth.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { signInWithRedirect, fetchAuthSession } from 'aws-amplify/auth'
@Injectable()
export class AuthGuard implements CanActivate {


  constructor(private _authService: AuthService, private _router: Router) {
  }

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return await this._authService.isAuthenticated()
      .then( async (result) => {
        if(result){
          return true;
        }
        else {
          console.log(result);
          localStorage.setItem('prev_url', state.url);
          // window.location.replace(environment.signIn);
          await signInWithRedirect();
          return false;
        }
      });

    // return  await fetchAuthSession()
    //         .then(data => {
    //           console.log(data);
    //           if (data.tokens && data.tokens.idToken){
    //             return true;
    //           }
    //           else{
    //             return false
    //           }
    //         })
    //         .catch(err => { return false;
    //         })
  }
}
